import { CircleHelp } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { Button } from '@/shared/ui/button'
import { Popover, PopoverContent, PopoverTrigger } from '@/shared/ui/popover'

/** Ajuda do topo: atalhos de teclado do painel. */
export function HelpMenu() {
  const { t } = useTranslation()

  const shortcuts = [
    { keys: ['Ctrl', 'K'], label: t('help.search') },
    { keys: ['Esc'], label: t('help.close') },
    { keys: ['Tab'], label: t('help.next') },
  ]

  return (
    <Popover>
      <PopoverTrigger
        render={
          <Button
            variant="outline"
            size="icon"
            className="text-muted-foreground"
            aria-label={t('help.label')}
          />
        }
      >
        <CircleHelp />
      </PopoverTrigger>
      <PopoverContent align="end" className="w-72 p-0">
        <p className="border-b px-4 py-3 text-xs font-extrabold tracking-[0.08em] text-muted-foreground uppercase">
          {t('help.shortcuts')}
        </p>
        <dl className="space-y-2.5 px-4 py-3 text-sm">
          {shortcuts.map((shortcut) => (
            <div key={shortcut.label} className="flex items-center justify-between gap-4">
              <dt>{shortcut.label}</dt>
              <dd className="flex gap-1">
                {shortcut.keys.map((key) => (
                  <kbd key={key} className="rounded-sm border border-input px-1.5 text-[11px] font-bold">
                    {key}
                  </kbd>
                ))}
              </dd>
            </div>
          ))}
        </dl>
      </PopoverContent>
    </Popover>
  )
}
